import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Modal, Typography } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { cdfService } from 'v2/services/cdfService';
import type { IFilterParams } from 'v2/services/cdfService/types';
import { useUserStore } from 'v2/store/User';

interface IProps {
  open: boolean;
  onClose: any;
  filterParams: IFilterParams;
}

const ModalReport: React.FC<IProps> = ({ open, onClose, filterParams }) => {
  const exportMutation = useMutation({
    mutationFn: (params: IFilterParams) => cdfService.export(params),
    onSuccess: () => {
      setFinished(true);
    },
    onError: () => {
      toast.error('Ops, erro ao tentar gerar relatório!');
    }
  });
  const [finished, setFinished] = useState(false);

  const { email } = useUserStore(({ originalUser }) => ({ email: originalUser.email }));

  const handleSubmit = useCallback(async () => {
    exportMutation.mutate(filterParams);
  }, [exportMutation, filterParams]);

  const handleClose = useCallback(() => {
    setFinished(false);
    onClose();
  }, [onClose]);

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title='Geração de relatório de documentos fiscais'
      width={640}
      footer={
        <div className='text-right'>
          <Button disabled={exportMutation.isPending} onClick={handleClose}>
            Fechar
          </Button>
          {!finished && (
            <Button
              loading={exportMutation.isPending}
              disabled={exportMutation.isPending}
              type='primary'
              onClick={handleSubmit}
              className='ml-2!'
            >
              {exportMutation.isPending ? 'Gerando...' : 'Gerar'}
            </Button>
          )}
        </div>
      }
    >
      {finished ? (
        <Typography>
          Geração do relatório solicitado com sucesso, você irá receber o relatório no e-mail <b>{email}</b> quando o
          processo finalizar.
        </Typography>
      ) : (
        <Typography>
          Ao gerar o relatório você irá receber uma cópia no e-mail <b>{email}</b> assim que o processo for finalizado.
        </Typography>
      )}
    </Modal>
  );
};

export default ModalReport;
